import { render, staticRenderFns } from "./qa.vue?vue&type=template&id=410f2a1b&scoped=true&"
import script from "./qa.vue?vue&type=script&lang=ts&"
export * from "./qa.vue?vue&type=script&lang=ts&"
import style0 from "./qa.vue?vue&type=style&index=0&id=410f2a1b&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410f2a1b",
  null
  
)

export default component.exports